/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import PageContentContainer from "../../Container/PageContentContainer";
import PageHeadline from "../../PageHeadline/PageHeadline";
import React from "react";
import AiLabPromptForge from "./PromptForge/AiLabPromptForge";
import AiLabOcr from "./Ocr/AiLabOcr";
import AiLabMediaObjectToTextQualityAssurance from "./MediaObjectToTextQualityAssurance/AiLabMediaObjectToTextQualityAssurance";

export default function AiLab() {
  return (
    <PageContentContainer>
      <PageHeadline main="👩🏻‍🔬🧪🤖 AI Tools" />

      <AiLabPromptForge />

      <AiLabOcr />

      <AiLabMediaObjectToTextQualityAssurance />
    </PageContentContainer>
  );
}
